import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`

const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 40px; 
      height: 40px;
    }`
  }
`

const FilterCalendarIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
    <SVG xmlns="http://www.w3.org/2000/svg" width="53.571" height="48.34" viewBox="0 0 53.571 48.34" isFromWidgetChoice={isFromWidgetChoice}>
      <g id="filter_calendar" transform="translate(0 -25)">
        <path className="fillHoverSVG" id="Tracé_4232" data-name="Tracé 4232" d="M101.918,249H98.569a1.569,1.569,0,1,0,0,3.139h3.348a1.569,1.569,0,1,0,0-3.139Z" transform="translate(-86.851 -200.563)" fill="#707070"/>
        <path className="fillHoverSVG" id="Tracé_4233" data-name="Tracé 4233" d="M101.918,313H98.569a1.569,1.569,0,1,0,0,3.139h3.348a1.569,1.569,0,1,0,0-3.139Z" transform="translate(-86.851 -257.866)" fill="#707070"/>
        <path className="fillHoverSVG" id="Tracé_4234" data-name="Tracé 4234" d="M101.918,377H98.569a1.569,1.569,0,1,0,0,3.139h3.348a1.569,1.569,0,1,0,0-3.139Z" transform="translate(-86.851 -315.17)" fill="#707070"/>
        <path className="fillHoverSVG" id="Tracé_4235" data-name="Tracé 4235" d="M229.918,249h-3.348a1.569,1.569,0,1,0,0,3.139h3.348a1.569,1.569,0,1,0,0-3.139Z" transform="translate(-201.458 -200.563)" fill="#707070"/>
        <path className="fillHoverSVG" id="Tracé_4236" data-name="Tracé 4236" d="M229.918,313h-3.348a1.569,1.569,0,1,0,0,3.139h3.348a1.569,1.569,0,1,0,0-3.139Z" transform="translate(-201.458 -257.866)" fill="#707070"/>
        <path className="fillHoverSVG" id="Tracé_4237" data-name="Tracé 4237" d="M229.918,377h-3.348a1.569,1.569,0,1,0,0,3.139h3.348a1.569,1.569,0,1,0,0-3.139Z" transform="translate(-201.458 -315.17)" fill="#707070"/>
        <path className="fillHoverSVG" id="Tracé_4238" data-name="Tracé 4238" d="M357.918,249h-3.348a1.569,1.569,0,1,0,0,3.139h3.348a1.569,1.569,0,0,0,0-3.139Z" transform="translate(-316.065 -200.563)" fill="#707070"/>
        <path className="fillHoverSVG" id="Tracé_4239" data-name="Tracé 4239" d="M357.918,313h-3.348a1.569,1.569,0,1,0,0,3.139h3.348a1.569,1.569,0,0,0,0-3.139Z" transform="translate(-316.065 -257.866)" fill="#707070"/>
        <path className="fillHoverSVG" id="Tracé_4240" data-name="Tracé 4240" d="M357.918,377h-3.348a1.569,1.569,0,1,0,0,3.139h3.348a1.569,1.569,0,0,0,0-3.139Z" transform="translate(-316.065 -315.17)" fill="#707070"/>
        <path className="fillHoverSVG" id="Tracé_4241" data-name="Tracé 4241" d="M48.863,29.185H45.1V26.569a1.569,1.569,0,0,0-3.139,0v2.616h-13.6V26.569a1.569,1.569,0,1,0-3.139,0v2.616h-13.6V26.569a1.569,1.569,0,0,0-3.139,0v2.616H4.708A4.714,4.714,0,0,0,0,33.894V68.631A4.714,4.714,0,0,0,4.708,73.34H48.863a4.714,4.714,0,0,0,4.708-4.708V33.894A4.714,4.714,0,0,0,48.863,29.185ZM3.139,33.894a1.571,1.571,0,0,1,1.569-1.569H8.475V34.94a1.569,1.569,0,1,0,3.139,0V32.324h13.6V34.94a1.569,1.569,0,1,0,3.139,0V32.324h13.6V34.94a1.569,1.569,0,0,0,3.139,0V32.324h3.767a1.571,1.571,0,0,1,1.569,1.569v6.173H3.139ZM48.863,70.2H4.708a1.571,1.571,0,0,1-1.569-1.569V43.206H50.432V68.631A1.571,1.571,0,0,1,48.863,70.2Z" fill="#707070"/>
      </g>
    </SVG>
  </IconContainer>
)

export default FilterCalendarIcon